import React, { useState } from 'react';
import { Form, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faGraduationCap,
  faChartLine,
  faRoute,
  faClock,
  faLayerGroup,
  faChevronRight
} from '@fortawesome/free-solid-svg-icons';
import './LayerControls.css';

interface LayerControlsProps {
  layers: {
    schools: boolean;
    priceHeatmap: boolean;
    commuteTimes: boolean;
    futureValue: boolean;
  };
  onToggleLayer: (layerId: string) => void;
}

const LayerControls: React.FC<LayerControlsProps> = ({ layers, onToggleLayer }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  
  // Count active layers
  const activeLayerCount = Object.values(layers).filter(Boolean).length;
  
  const layerConfig = [
    {
      id: 'schools',
      label: 'School Quality',
      icon: faGraduationCap,
      color: '#10b981',
      description: 'A+ to F school ratings'
    },
    {
      id: 'priceHeatmap',
      label: 'Price Heatmap',
      icon: faChartLine,
      color: '#f59e0b',
      description: 'Market value analysis'
    },
    {
      id: 'commuteTimes',
      label: 'Commute Times',
      icon: faRoute,
      color: '#3b82f6',
      description: 'Travel time to work'
    },
    {
      id: 'futureValue',
      label: 'Future Value AI',
      icon: faClock,
      color: '#8b5cf6',
      description: '5-year predictions'
    }
  ];

  return (
    <div className={`layer-controls ${isExpanded ? 'expanded' : 'collapsed'}`}>
      <Button 
        variant="dark" 
        className="layer-toggle-btn"
        onClick={() => setIsExpanded(!isExpanded)}
        title={`${activeLayerCount} layers active`}
      >
        <FontAwesomeIcon icon={faLayerGroup} className="me-2" />
        <span className="btn-text">Layers</span>
        {activeLayerCount > 0 && (
          <span className="active-count">{activeLayerCount}</span>
        )}
        <FontAwesomeIcon 
          icon={faChevronRight} 
          className={`chevron ${isExpanded ? 'rotated' : ''}`} 
        />
      </Button>
      
      {isExpanded && (
        <div className="layer-menu">
          <div className="layer-header">
            <h6 className="layer-title">AI-Powered Layers</h6>
            <small className="text-muted">Enhance your search</small>
          </div>
          
          <div className="layer-list">
            {layerConfig.map((layer) => (
              <div key={layer.id} className="layer-item">
                <Form.Check
                  type="switch"
                  id={`layer-${layer.id}`}
                  checked={layers[layer.id as keyof typeof layers]}
                  onChange={() => onToggleLayer(layer.id)}
                  className="custom-switch"
                />
                <div className="layer-info">
                  <div className="layer-label">
                    <FontAwesomeIcon 
                      icon={layer.icon} 
                      className="layer-icon" 
                      style={{ color: layer.color }}
                    />
                    <span>{layer.label}</span>
                  </div>
                  <small className="layer-description">{layer.description}</small>
                </div>
              </div>
            ))}
          </div>
          
          <div className="layer-footer">
            <small className="ai-badge">
              <span className="pulse"></span>
              Powered by Theta AI
            </small>
          </div>
        </div>
      )}
    </div>
  );
};

export default LayerControls;